import { DateTime } from './commons';
import { IAttachment, WebAppAttachmentTypes } from './IAttachment';
import { IChannel } from './IChannel';
import { IMessageableEntity } from './IMessageableEntity';
import { IMessageTemplate } from './IMessageTemplate';
import { IRepairOrder } from './IRepairOrder';
import { WorkspaceModule } from './IWorkspace';

export interface IMessage {
  outcoming: boolean;
  body: string;
  uid: string;
  createdBy: IMessageableEntity;
  createdAt: Date;
  deliveryStatus: IMessageDeliveryStauts;

  // optionals
  attachments?: IAttachment[];
  isDeleted?: boolean;
  repairOrder?: IRepairOrder;
  systemTags?: string[];
  isLoadingTranslation?: boolean;
  errorTranslation?: boolean;
  source?: MessageSource;
  translation?: string;
  type?: MessageType;
  autor?: IMessageAutor;
  reactions?: IReaction[];
  hover?: boolean;
  errorMessage?: string;
  errorCode?: number;
  origin?: string;
}

export interface IReactionGroup {
  body: string;
  reactions: IReaction[];
  tooltip: string;
  mine?: boolean;
}

export interface IMessageAutor {
  displayName: string;
  id: string;
  profileImageURL?: string;
}

export interface ISocketMessage {
  message: IMessage;
  member: string;
  createdBy: IMessageableEntity;
  type: string;
  channel: IChannel;
  memberUID: string;
  enabled: boolean;
  reaction?: IReaction;
  userEntityUID?: string;
  awaySettings?: IAwaySettingsWebsocket;
  filters?: { module: WorkspaceModule };
}

export interface IAwaySettingsWebsocket {
  endDate: string;
  delegateUID: string;
  customMessage: string;
}

export interface IReaction {
  body: string;
  createdBy: IMessageableEntity;
}

export interface IMessageDeliveryStauts {
  anyDelivered?: boolean;
  anyFailed?: boolean;
  anyRead?: boolean;
  anySent?: boolean;
  sending?: boolean;
  failed?: { errorDescription: string; errorCode: number }[];
}

export type DeliveryStatusType = 'sending' | 'failed' | 'delivered' | 'read' | 'sent';

export const DeliveryStatusTypesOptions: {
  delivered: IMessageDeliveryStauts;
  failed: IMessageDeliveryStauts;
  read: IMessageDeliveryStauts;
  sending: IMessageDeliveryStauts;
  sent: IMessageDeliveryStauts;
} = {
  read: {
    anyRead: true,
  },
  sending: {
    sending: true,
  },
  failed: {
    anyFailed: true,
  },
  delivered: {
    anyDelivered: true,
  },
  sent: {
    anySent: true,
  },
};

export interface IPartialMessage {
  channel: IChannel;
  message: string;
  attachments: IAttachment[];
  systemTags?: string[];
  template?: IMessageTemplate;
}

export interface IMessageFilters {
  phoneNumber?: string;
  externalId?: string;
  orderId?: string;
  conversationId?: string;
}

export interface Suggestion {
  text: string;
}

export interface IMessageOldDto extends Omit<IMessage, 'createdAt'> {
  createdAt: DateTime;
  multimedia: {
    mimeType: WebAppAttachmentTypes;
    s3FileKey: string;
    url: string;
  };
}

export enum MessageType {
  HTML = 'HTML',
  TEXT = 'TEXT',
}

export enum MessageSource {
  APPLICATION = 'APPLICATION',
  MMS = 'MMS',
  SMS = 'SMS',
}
